@if (!this.loading) {
  <!-- Header mejorado -->
  <app-breadcrumb
    listado="/main/vehiculos/vehiculos"
    etiquetaListado="Vehículos"
    [titulo]="activo?.identificacion"
  ></app-breadcrumb>

  <!-- Encabezado: la identidad del vehículo (skill detalle-entidad) -->
  <header class="encabezado">
    <div class="encabezado-avatar"><mat-icon>directions_car</mat-icon></div>
    <div class="encabezado-texto">
      <h1>{{ activo?.identificacion }}</h1>
      @if (activo?.vehiculo?.patente) {
        <span class="encabezado-nombre encabezado-patente">
          {{ helper.formatPatente(activo.vehiculo.patente) }}
        </span>
      }
      <div class="encabezado-chips">
        @if (
          etiquetaTipoYFuncion(activo?.vehiculo?.tipo, activo?.funcion, ' · ');
          as tipo
        ) {
          <span class="chip">
            <mat-icon>category</mat-icon>
            {{ tipo }}
          </span>
        }
        @if (activo?.vehiculo?.estado; as estado) {
          <span class="chip" [class]="'chip estado-' + claseEstado(estado)">
            <mat-icon>build</mat-icon>
            {{ estado }}
          </span>
        }
        @for (chip of chips; track $index) {
          <span class="chip">
            @if (chip.icon) {
              <mat-icon>{{ chip.icon }}</mat-icon>
            }
            {{ chip.label }}
          </span>
        }
      </div>
    </div>
    <div class="encabezado-acciones">
      <button irxBotonIcono (click)="verEnMapa()" tooltip="Ver en mapa">
        <mat-icon>map</mat-icon>
      </button>
      @if (puedeCrearRegla()) {
        <button
          irxBotonIcono
          (click)="crearRegla()"
          tooltip="Crear regla de evento"
        >
          <mat-icon>rule</mat-icon>
        </button>
      }
      @if (activo?.vehiculo?.idRecorridoDinamico && puedeEditarRecorridos) {
        <button
          irxBotonIcono
          (click)="finalizarRecorridoDinamico()"
          tooltip="Finalizar recorrido dinámico"
        >
          <mat-icon>task_alt</mat-icon>
        </button>
      }
      @if (puedeEditar) {
        <button irxBotonIcono (click)="editar()" tooltip="Editar vehículo">
          <mat-icon>edit</mat-icon>
        </button>
      }
    </div>
  </header>

  <mat-tab-group
    [(selectedIndex)]="selectedTab"
    (selectedTabChange)="tabChanged($event)"
    class="tabs-detalle"
  >
    <!-- Info -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">info</mat-icon>
        <span>Info</span>
      </ng-template>
      <ng-template matTabContent>
        <app-detalles-vehiculo-info
          [vehiculo]="activo"
        ></app-detalles-vehiculo-info>
      </ng-template>
    </mat-tab>

    <!-- Viajes -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">route</mat-icon>
        <span>Viajes</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-viajes [vehiculo]="activo"></app-listado-viajes>
      </ng-template>
    </mat-tab>

    <!-- Cumplimiento de Recorrido -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">checklist</mat-icon>
        <span>Cumplimiento de Recorrido</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-cumplimientos-recorrido
          [vehiculo]="activo"
        ></app-listado-cumplimientos-recorrido>
      </ng-template>
    </mat-tab>

    <!-- Historial de Recorridos Dinámicos -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">alt_route</mat-icon>
        <span>Recorridos Dinámicos</span>
      </ng-template>
      <ng-template matTabContent>
        <app-historial-recorridos-dinamicos
          [vehiculo]="activo"
        ></app-historial-recorridos-dinamicos>
      </ng-template>
    </mat-tab>

    <!-- Historial de Eventos -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">report</mat-icon>
        <span>Historial Eventos</span>
      </ng-template>
      <ng-template matTabContent>
        <!-- <app-listado-eventos-historico
          [id]="activo?._id"
          tipo="Vehiculo"
        ></app-listado-eventos-historico> -->
        <app-eventos-genericos-historico
          [id]="activo?._id"
        ></app-eventos-genericos-historico>
      </ng-template>
    </mat-tab>

    <!-- Historial Reportes -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">description</mat-icon>
        <span>Historial Reportes</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-reportes-genericos
          [entidad]="activo"
          tipoEntidad="Vehiculo"
          [tipoValoresReporte]="[
            helper.tipoTrackerATipoValoresReporte(activo.tracker),
          ]"
        ></app-listado-reportes-genericos>
      </ng-template>
    </mat-tab>

    <!-- Combustible -->
    <!-- Solo si el vehículo tiene el sensor -->
    @if (sensores.combustible) {
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">local_gas_station</mat-icon>
          <span>Combustible</span>
        </ng-template>
        <ng-template matTabContent>
          <app-listado-reportes-combustible
            [idActivo]="activo?._id"
          ></app-listado-reportes-combustible>
        </ng-template>
      </mat-tab>
    }

    <!-- Temperatura -->
    <!-- Solo si el vehículo tiene el sensor -->
    @if (sensores.temperatura) {
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">thermostat</mat-icon>
          <span>Temperatura</span>
        </ng-template>
        <ng-template matTabContent>
          <app-listado-reportes-temperatura
            [idActivo]="activo?._id"
          ></app-listado-reportes-temperatura>
        </ng-template>
      </mat-tab>
    }

    <!-- Comandos -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">send</mat-icon>
        <span>Comandos</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-comandos [activo]="activo"></app-listado-comandos>
      </ng-template>
    </mat-tab>

    <!-- Codigos -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">integration_instructions</mat-icon>
        <span>Códigos Eventos</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-configs-eventos
          [dispositivo]="activo"
          tipo="Activo"
          [botonCrearMostrar]="botonCrearMostrar()"
        ></app-listado-configs-eventos>
      </ng-template>
    </mat-tab>

    <!-- Eventos Personalizados -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">rule</mat-icon>
        <span>Eventos Personalizados</span>
      </ng-template>
      <ng-template matTabContent>
        @if (params) {
          <app-listado-config-evento-usuario
            [params]="params"
          ></app-listado-config-evento-usuario>
        }
      </ng-template>
    </mat-tab>

    <!-- Certificados -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">verified</mat-icon>
        <span>Certificados</span>
      </ng-template>
      <ng-template matTabContent>
        @if (paramsCertificados) {
          <app-listado-certificado-entidad
            [params]="paramsCertificados"
          ></app-listado-certificado-entidad>
        }
      </ng-template>
    </mat-tab>

    <!-- Notas -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">note</mat-icon>
        <span>Notas</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-notas
          [idAsignado]="activo._id"
          tipo="Nota"
          tipoDispositivo="Vehiculo"
        ></app-listado-notas>
      </ng-template>
    </mat-tab>

    <!-- Contactos -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">contacts</mat-icon>
        <span>Contactos</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-notas
          [idAsignado]="this.activo._id"
          tipo="Contacto"
          tipoDispositivo="Vehiculo"
        ></app-listado-notas>
      </ng-template>
    </mat-tab>

    <!-- Documentos -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">folder</mat-icon>
        <span>Documentos</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-documentos
          class="cardContentPestaña"
          [idEntidad]="activo._id"
          [idCliente]="activo.idCliente"
          tipoEntidad="Vehiculo"
        ></app-listado-documentos>
      </ng-template>
    </mat-tab>

    <!-- Servicios del vehículo: combustible, mantenimiento y gastos -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">receipt_long</mat-icon>
        <span>Servicios</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-servicios
          categoria="Vehiculo"
          [idActivo]="activo?._id"
          [idCliente]="activo?.idCliente"
        ></app-listado-servicios>
      </ng-template>
    </mat-tab>

    <!-- Recordatorios de mantenimiento -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">alarm</mat-icon>
        <span>Recordatorios</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-recordatorios
          categoria="Vehiculo"
          [idActivo]="activo?._id"
          [idCliente]="activo?.idCliente"
        ></app-listado-recordatorios>
      </ng-template>
    </mat-tab>

    <!-- Servicio Técnico -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">build</mat-icon>
        <span>Servicio Técnico</span>
      </ng-template>
      <ng-template matTabContent>
        <!-- <app-eventos-tecnicos [activo]="activo"></app-eventos-tecnicos> -->
        <app-eventos-tecnicos-genericos
          [id]="activo?._id"
        ></app-eventos-tecnicos-genericos>
      </ng-template>
    </mat-tab>

    <!-- Asignaciones -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">assignment</mat-icon>
        <span>Asignaciones</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-asignacions
          [idEntidad]="activo?._id"
          [tipoEntidad]="'modificada'"
        ></app-listado-asignacions>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
} @else {
  <app-detalle-esqueleto
    icono="directions_car"
    listado="/main/vehiculos/vehiculos"
    etiquetaListado="Vehículos"
    [pestanas]="19"
  ></app-detalle-esqueleto>
}
